import { ChevronLeft, ChevronRight } from "lucide-react"
import ReactCalendar from "react-calendar"
import type { CalendarProps as ReactCalendarProps } from "react-calendar"
import "react-calendar/dist/Calendar.css"
import "./calendar.css"

import { cn } from "@/lib/utils"

export interface CalendarProps extends Omit<ReactCalendarProps, 'onChange' | 'value'> {
  mode?: 'single' | 'range'
  selected?: Date | { from?: Date; to?: Date }
  onSelect?: (date: Date | { from?: Date; to?: Date } | undefined) => void
  disabled?: (date: Date) => boolean
  className?: string
}

function Calendar({
  className,
  mode = 'single',
  selected,
  onSelect,
  disabled,
  ...props
}: CalendarProps) {
  const handleChange = (value: any) => {
    if (mode === 'range') {
      if (Array.isArray(value) && value.length === 2) {
        onSelect?.({ from: value[0], to: value[1] })
      } else if (Array.isArray(value) && value.length === 1) {
        onSelect?.({ from: value[0], to: undefined })
      } else {
        onSelect?.(undefined)
      }
    } else {
      onSelect?.(value)
    }
  }

  const getValue = () => {
    if (mode === 'range' && selected && typeof selected === 'object' && 'from' in selected) {
      if (selected.from && selected.to) {
        return [selected.from, selected.to] as [Date, Date]
      } else if (selected.from) {
        return selected.from
      }
      return null
    }
    return selected as Date || null
  }

  return (
    <div className={cn("react-calendar-container", className)}>
      <ReactCalendar
        onChange={handleChange}
        value={getValue()}
        selectRange={mode === 'range'}
        tileDisabled={disabled ? ({ date }) => disabled(date) : undefined}
        prev2Label={null}
        next2Label={null}
        prevLabel={<ChevronLeft className="h-4 w-4" />}
        nextLabel={<ChevronRight className="h-4 w-4" />}
        {...props}
      />
    </div>
  )
}

Calendar.displayName = "Calendar"

export { Calendar }